import type { SVGProps } from 'react';

type ToolbarIconProps = SVGProps<SVGSVGElement>;

export function BoldToolbarIcon(props: ToolbarIconProps) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path
        fill="currentColor"
        d="M7 4h6.5c2.4 0 4.2 1.55 4.2 3.8 0 1.55-.82 2.68-2.05 3.25C17.22 11.56 18 12.85 18 14.6c0 2.72-2.1 4.4-4.85 4.4H7V4Zm3.1 6.05h3c.95 0 1.55-.62 1.55-1.55s-.6-1.5-1.55-1.5h-3v3.05Zm0 5.95h3.3c.98 0 1.62-.66 1.62-1.65s-.64-1.65-1.62-1.65h-3.3V16Z"
      />
    </svg>
  );
}

export function UnderlineToolbarIcon(props: ToolbarIconProps) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path
        fill="currentColor"
        d="M6.8 4h2.75v7.65c0 1.85.95 2.95 2.45 2.95s2.45-1.1 2.45-2.95V4h2.75v7.8c0 3.35-2.1 5.35-5.2 5.35s-5.2-2-5.2-5.35V4Z"
      />
      <path fill="currentColor" d="M5.5 19h13v2h-13v-2Z" />
    </svg>
  );
}

export function ItalicToolbarIcon(props: ToolbarIconProps) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path fill="currentColor" d="M10.2 4h8v2.55h-2.65l-3.1 10.9h2.65V20h-8v-2.55h2.65l3.1-10.9H10.2V4Z" />
    </svg>
  );
}

export function BulletListToolbarIcon(props: ToolbarIconProps) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path fill="currentColor" d="M5 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm0 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM9 4.75h10v1.8H9v-1.8Zm0 6.5h10v1.8H9v-1.8Zm0 6.5h10v1.8H9v-1.8Z" />
    </svg>
  );
}

export function TemplateToolbarIcon(props: ToolbarIconProps) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path
        fill="currentColor"
        d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 12h8v1.5H8V12zm0 3h8v1.5H8V15zm0 3h5.5V19.5H8V18z"
      />
    </svg>
  );
}

export function OrderedListToolbarIcon(props: ToolbarIconProps) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" {...props}>
      <path fill="currentColor" d="M4.3 5.6H3.2V4.3h2.6v5.2H4.3V5.6Zm-.95 6.3c0-1.05.82-1.85 2.02-1.85 1.12 0 1.95.7 1.95 1.68 0 .58-.25 1.02-.86 1.58l-1.08.97h2.04v1.27H3.3v-1.1l2-1.85c.32-.3.43-.48.43-.72 0-.3-.22-.5-.55-.5-.38 0-.62.24-.62.63H3.35v-.11Zm1.8 8.35c-1.15 0-2-.62-2.05-1.65h1.32c.05.35.32.55.72.55.42 0 .68-.22.68-.58 0-.38-.28-.6-.78-.6h-.48v-1.02l1.02-.9H3.3V14.8h4v1.08l-1.12.95c.72.18 1.15.75 1.15 1.52 0 1.12-.88 1.9-2.18 1.9ZM10 4.75h10v1.8H10v-1.8Zm0 6.5h10v1.8H10v-1.8Zm0 6.5h10v1.8H10v-1.8Z" />
    </svg>
  );
}
